// extracted by mini-css-extract-plugin
export var banner = "index-module--banner--97a84";
export var bottom = "index-module--bottom--89277";
export var bottomContent = "index-module--bottomContent--c2688";
export var buttonGroup = "index-module--buttonGroup--3ab65";
export var contactButton = "index-module--contactButton--234b0";
export var content = "index-module--content--0223a";
export var days = "index-module--days--28666";
export var desc = "index-module--desc--2bb44";
export var gradientRotation = "index-module--gradientRotation--e4d1b";
export var icon = "index-module--icon--ce4ea";
export var label = "index-module--label--73a01";
export var left = "index-module--left--fa19b";
export var nodeButton = "index-module--nodeButton--8bd21";
export var right = "index-module--right--712e9";
export var rightBg = "index-module--rightBg--abbca";
export var timeSection = "index-module--timeSection--451d4";
export var title = "index-module--title--fd521";